import ApiService from "@/core/services/api.service";

export const AUDIT_GET_LIST = "audit/get-transactions"
export const AUDIT_GET_STUDENT_AMOUNT = "audit/get-student-amount"
export const AUDIT_UPDATE_DETAIL = "audit/update"
export const AUDIT_CREATE_STUDENT_AMOUNT = "audit/audit-student-amount"
export const AUDIT_PAYOO_STATUS = "audit/audit-payoo"
export const GET_STUDENT_AMOUNT_RECEIPT = "audit/get-student-amount-receipt"
export const UPDATE_STUDENT_AMOUNT_RECEIPT = "audit/update-student-amount-receipt"

const state = {};
const getters = {};
const actions = {

    [AUDIT_GET_LIST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${AUDIT_GET_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response)
                });
        });
    },

    [AUDIT_UPDATE_DETAIL](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${AUDIT_UPDATE_DETAIL}/${payload.id}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response)
                });
        });
    },

    [AUDIT_GET_STUDENT_AMOUNT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${AUDIT_GET_STUDENT_AMOUNT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response)
                });
        });
    },

    [AUDIT_CREATE_STUDENT_AMOUNT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${AUDIT_CREATE_STUDENT_AMOUNT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response)
                });
        });
    },
    [AUDIT_PAYOO_STATUS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${AUDIT_PAYOO_STATUS}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response)
                });
        });
    },

    [GET_STUDENT_AMOUNT_RECEIPT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${GET_STUDENT_AMOUNT_RECEIPT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response)
                });
        });
    },

    [UPDATE_STUDENT_AMOUNT_RECEIPT](context, payload) {
    return new Promise((resolve, reject) => {
        ApiService.post(`${UPDATE_STUDENT_AMOUNT_RECEIPT}`, payload)
            .then(({data}) => {
                resolve(data);
            })
            .catch(({response}) => {
                reject(response)
            });
    });
},
};

const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters
};